import React, { createContext, useContext, useMemo } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme, cn_theme } from '../styles/theme';
import { getDomain } from '../utils/config';

const ThemeContext = createContext();

const ThemeContextProvider = ({ children }) => {
	const currentDomain = getDomain();
	const lng = new URLSearchParams(window.location.search).get('lng');

	const t = useMemo(() => {
		if (lng === 'cn') return cn_theme;
		switch (currentDomain) {
			case 'onsemi.cn':
				return cn_theme;
			case 'onsemi.com':
				return theme;
			default:
				return theme; // Default theme
		}
	}, [currentDomain, lng]);

	return (
		<ThemeContext.Provider value={t}>
			<ThemeProvider theme={t}>{children}</ThemeProvider>
		</ThemeContext.Provider>
	);
};

const useThemeContext = () => useContext(ThemeContext);

export { ThemeContextProvider, useThemeContext };
